import { Component } from '@angular/core';
import { formatMessage } from "devextreme/localization";
import * as dayjs from 'dayjs'
import {AppConstats} from "../../../utils/app.constants";
import {ContractorType} from "../../../../core/enums/contractor-type.enum";
import {Country} from "../../../../core/enums/country.enum";
import {OrderCostType} from "../../../../core/enums/order-cost-type.enum";
import {OrderCostStatus} from "../../../../core/enums/order-cost-status.enum";
import {OrderPaymentType} from "../../../../core/enums/order-payment-type.enum";
import {OrderCostSettlementMethod} from "../../../../core/enums/order-cost-settlement-method.enum";
import {OrderStatus} from "../../../../core/enums/order-status.enum";
import {TransportOrderStatus} from "../../../../core/enums/transport-order-status.enum";
import {TransportOrderOfferStatus} from "../../../../core/enums/transport-order-offer-status.enum";
import {Currency} from "../../../../core/enums/currency.enum";
import {VehicleMake} from "../../../../core/enums/vehicle-make.enum";


@Component({
  selector: 'app-base',
  template: ``,
  styleUrls: ['./base.component.scss']
})
export class BaseComponent {

  dateFormat: string = AppConstats.DateFormat;
  dateTimeFormat: string = AppConstats.DataTimeFormat;

  dateFormatWidth: number = 100;
  dateTimeFormatWidth: number = 140;
  formatMessage = formatMessage;

  colCountByScreen = {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 4
  };

  public excludeSpaces = (e: any) => {
    let value = e.component.option("text");
    if (e.event.keyCode === 32) {
      e.event.preventDefault();
    }
  }

  public excludeSpacesAndToUpper = (e: any) => {
    let value = e.component.option("text");
    if (e.event.keyCode === 32) {
      e.event.preventDefault();
    }
    e.component.option("value", value.toUpperCase());
  }

  formatDate(date: Date) {
    return dayjs(date).format('YYYY-MM-DD');
  }

  public getContractorTypeName(value: number) {
    let enumValue = ContractorType[value];
    return formatMessage('ContractorType' + "." + enumValue);
  }

  public getCountryName(value: number) {
    let enumValue = Country[value];
    return formatMessage('Country' + "." + enumValue);
  }

  public getCurrencyName(value: number) {
    let enumValue = Currency[value];
    return formatMessage('Currency' + "." + enumValue);
  }

  public getOrderStatus(value: number) {
    let enumValue = OrderStatus[value];
    return formatMessage('OrderStatus' + "." + enumValue);
  }

  public getOrderCostType(value: number) {
    let enumValue = OrderCostType[value];
    return formatMessage('OrderCostType' + "." + enumValue);
  }

  public getOrderCostStatus(value: number) {
    let enumValue = OrderCostStatus[value];
    return formatMessage('OrderCostStatus' + "." + enumValue);
  }

  public getOrderPaymentType(value: number) {
    let enumValue = OrderPaymentType[value];
    return formatMessage('OrderPaymentType' + "." + enumValue);
  }

  public getOrderCostSettlementMethod(value: number) {
    let enumValue = OrderCostSettlementMethod[value];
    return formatMessage('OrderCostSettlementMethod' + "." + enumValue);
  }

  public getTransportOrderStatus(value: number) {
    let enumValue = TransportOrderStatus[value];
    return formatMessage('TransportOrderStatus' + "." + enumValue);
  }

  public getTransportOrderOfferStatus(value: number) {
    let enumValue = TransportOrderOfferStatus[value];
    return formatMessage('TransportOrderOfferStatus' + "." + enumValue);
  }

  public getMakeName(value: number) {

    let makeEnum = VehicleMake[value];
    return formatMessage('VehicleMake' + "." + makeEnum)
  }
}
